import * as React from 'react'

interface Props {
  auditCompleteMode: string
}

export const AuditCompleteExample = (props: Props) => {
  return props.auditCompleteMode === 'replace' ? (
    <div className='d-flex'>
      <div className='fa fa-exclamation-triangle text-muted fa-4x mr-3 mt-4' />
      <div>
        <div>Your inventory will be replaced by your new audit values.</div>
        <small className='text-muted'>
          <div>Example</div>
          <div>You start with 10 units. You begin your audit and count 12.</div>
          <div>Your final inventory value will be 12 with a +2 discrepancy.</div>
        </small>
      </div>
    </div>
  ) : (
    <div className='d-flex'>
      <div className='fa fa-exclamation-triangle text-muted fa-4x mr-3 mt-4' />
      <div>
        <div>Your inventory will be adjusted relative to when you started this audit.</div>
        <small className='text-muted'>
          <div>Example</div>
          <div>You start with 10 units. You begin your audit and count 12.</div>
          <div>During this time, 2 units are transferred into inventory.</div>
          <div>
            Because inventory is adjusted relative the the start of the audit, your final inventory
            value will be 14.
          </div>
        </small>
      </div>
    </div>
  )
}
